import { PhoneNumberUtil } from 'google-libphonenumber';
import * as yup from 'yup';

export const emailValidation = (value: string) => {
  if (!value) return true;

  const atParts = value.split('@');
  if (atParts.length !== 2) return false;

  const [local, domain] = atParts;
  if (!local || !domain) return false;

  const lastDot = domain.lastIndexOf('.');
  if (lastDot === -1) return false;

  const afterDot = domain.substring(lastDot + 1);
  if (afterDot.length < 2) return false;

  if (!/^[a-zA-Z]+$/.test(afterDot)) return false;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(value)) return false;

  return true;
};

const phoneUtil = PhoneNumberUtil.getInstance();
export const validatePhoneNumber = (value: string | undefined | null) => {
  const str = typeof value === 'string' ? value : '';
  const trimmed = str.trim();
  if (trimmed === '' || trimmed.length <= 3) {
    return true;
  }
  try {
    const number = phoneUtil.parse(trimmed);
    return phoneUtil.isValidNumber(number);
  } catch {
    return false;
  }
};

export const nullableString = () => yup.string().nullable();
export const nullableNumber = () => yup.number().nullable();